export const LabelError = ({ children }: React.PropsWithChildren) => {
  const errorMessage = children as string;

  return (
    <div data-elements={errorMessage} className={'text-body-large text-danger-default'}>
      {children}
    </div>
  );
};
